import overlay_img from 'images/loginb2.webp'
import {useFormik} from 'formik'
import React, {useMemo, useState} from 'react'
import {AuthSignHeader} from 'i18n/AuthSignHeader'
import {LocalLink} from 'i18n/LocalLink'
import {getPasswordResetSchema} from 'utils/validation-schema'
import {useI18n} from 'i18n/I18nContext'
import {useAuth} from 'attendee/Auth/Providers/AuthProvider'
import {routes} from 'routes/routes'
import {PasswordRecoverUpdateData} from 'attendee/Auth/Interfaces/password_recover'
import {useQueryParams} from 'utils/lib/url'
import {toast} from 'react-toastify'

export function ResetPassword() {
  const {token, email} = useQueryParams()

  const [isBtnDisable, setBtnDisable] = useState(false)
  const {t} = useI18n()
  const passwordResetSchema = useMemo(() => getPasswordResetSchema(t), [t])

  const {passwordReset} = useAuth()

  const {handleSubmit, handleBlur, handleChange, values, errors, touched} =
    useFormik({
      initialValues: {
        password: '',
        password_confirmation: '',
      },
      validationSchema: passwordResetSchema,
      onSubmit: async (values: PasswordRecoverUpdateData) => {
        setBtnDisable(true)
        const resetResult = await passwordReset(
          values,
          token ?? '',
          email ?? '',
        )

        if (resetResult === true) {
          toast.success(t('auth.passwordResetToastOk'))
        }

        setBtnDisable(false)
      },
    })

  return (
    <>
      <main className={`body-area bd-theme-light`}>
        <section className="signin__area">
          <div className="sign__main-wrapper">
            <div className="sign__left">
              <AuthSignHeader
                logo={
                  <div className="sign__logo">
                    <LocalLink to={routes.index}>
                      <img
                        style={{width: '150px', height: 'auto'}}
                        className="logo-black"
                        src={process.env.PUBLIC_URL + '/logo-dark.svg'}
                        alt={t('logo.alt')}
                      />
                    </LocalLink>
                  </div>
                }
                navLinks={
                  <div className="sign__link custome_link">
                    <LocalLink className="sign__link-active" to={routes.login}>
                      {t('common.login')}
                    </LocalLink>
                    <LocalLink className="sign__link-text" to={routes.register}>
                      {t('common.register')}
                    </LocalLink>
                  </div>
                }
              />
              <div className="sign__center-wrapper text-center mt-90">
                <div className="sign__title-wrapper mb-40">
                  <h3 className="sign__title">
                    {t('auth.passwordResetTitle')}
                  </h3>
                  <p>{t('auth.passwordResetSubtitle')}</p>
                </div>
                <div className="sign__input-form text-center">
                  <form onSubmit={handleSubmit}>
                    <div className="sign__input mb-32">
                      <input
                        type="password"
                        placeholder={t('auth.passwordResetNewPlaceholder')}
                        name="password"
                        defaultValue={values.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                      />
                      <span>
                        {' '}
                        <i className="flaticon-password"></i>
                      </span>{' '}
                      <br />
                      {touched.password && (
                        <ErrorMsg errors={errors.password} />
                      )}
                    </div>

                    <div className="sign__input mb-32">
                      <input
                        type="password"
                        placeholder={t('auth.passwordResetConfirmPlaceholder')}
                        name="password_confirmation"
                        defaultValue={values.password_confirmation}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                      />
                      <span>
                        {' '}
                        <i className="flaticon-password"></i>
                      </span>{' '}
                      <br />
                      {touched.password_confirmation && (
                        <ErrorMsg errors={errors.password_confirmation} />
                      )}
                    </div>

                    <div className="sing__button mb-20">
                      <button
                        disabled={isBtnDisable}
                        className={
                          isBtnDisable
                            ? 'disableBtnStyle w-100 mb-20'
                            : 'input__btn w-100 mb-20'
                        }
                        type="submit"
                      >
                        {t('auth.passwordResetSubmit')}
                      </button>
                    </div>
                  </form>
                  <div className="if__account mt-85">
                    <p>
                      {t('auth.passwordRecoverFooterPrompt')}
                      <LocalLink to={routes.register}>
                        <br /> {t('common.register')}
                      </LocalLink>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="sign__right">
              <div
                className="sign__input-thumb"
                style={{
                  backgroundImage: `url(${overlay_img})`,
                  backgroundPosition: 'center',
                  backgroundSize: 'contain',
                }}
              ></div>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}

const ErrorMsg = ({errors}: any) => {
  return (
    <>
      <p className="error-msg" style={{color: 'red'}}>
        {errors}
      </p>
    </>
  )
}
